import { getMessages } from '../../../../../../../store/constants';

export const DAY_LENGTH = 1000 * 60 * 60 * 24;

export const DATEPICKER_ITEM_TO_ERROR = getMessages().getText('datepicker.to.error');
export const DATEPICKER_ITEM_FROM_ERROR = getMessages().getText('datepicker.from.error');
